/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_TotalInputs */

const en_matching_score_total = /** @type {(inputs: Matching_Score_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total score`)
};

const de_matching_score_total = /** @type {(inputs: Matching_Score_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtergebnis`)
};

/**
* | output |
* | --- |
* | "Total score" |
*
* @param {Matching_Score_TotalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_total = /** @type {((inputs?: Matching_Score_TotalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_TotalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_total(inputs)
	return en_matching_score_total(inputs)
});